export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8871.983c4ed9.jpg";